import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTabsModule } from '@angular/material/tabs';

import { BaseUiModule, NumericInlineInputComponent, ResourceImageDirective } from '@mitsubishi/shared/ui';

import { NgSelectModule } from '@ng-select/ng-select';
import { FormlyModule } from '@ngx-formly/core';

import { typeComponents, types } from './types';
import { ResourceTypeComponent } from './types/resource-type/resource-type.component';
import { wrapperComponents, wrappers } from './wrappers';
import { CardWrapperComponent } from './wrappers/card-wrapper/card-wrapper.component';
import { TableWrapperCellComponent } from './wrappers/table-wrapper/table-wrapper-cell/table-wrapper-cell.component';

@NgModule({
  imports: [
    CommonModule,
    MatTabsModule,
    BaseUiModule,
    FormlyModule.forRoot({
      wrappers: wrappers,
      types: types,
    }),
    NgSelectModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    FormsModule,
    TableWrapperCellComponent,
    NumericInlineInputComponent,
    ResourceImageDirective,
  ],
  declarations: [...wrapperComponents, ...typeComponents, ResourceTypeComponent],
  exports: [CardWrapperComponent],
})
export class ApmFormlyModule {}
